import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-scroll'

import { Button } from '../../common'
import { getIsLegalFlow } from '../../../redux/slices/userSlice'

import './styles.scss'

const Card = ({ image, accent, title, description }) => {
	const isLegalFlow = useSelector(getIsLegalFlow)

	return (
		<div className="card">
			<img
				src={`images/sale/${image}.png`}
				alt={image}
				className="card__image"
			/>
			<h3 className="card__title">
				{accent}
				<br />
				{title}
			</h3>
			<p className="card__description">{description}</p>
			<div className="card__button-wrapper">
				<Link
					to="price"
					smooth={true}
					duration={1000}
					spy={true}
					exact="true"
					offset={-100}
				>
					<Button buttonText={`Try ${isLegalFlow ? 'now' : 'for free'}`} />
				</Link>
			</div>
		</div>
	)
}

export { Card }
